module.exports = __webpack_public_path__ + "164676bbf662ecb89d0d5c083d4cb503.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/action-icons/essays.png
// module id = 944
// module chunks = 0